import { useState, useEffect } from 'react';

const Waiting = ({
  count = 2,
  activeColor = 'rgb(50, 50, 50)',
  defaultColor = 'rgb(198, 198, 198)',
  speed = 200,
  waitingStyle = {},
  circleStyle = {},
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % count);
    }, speed);

    return () => clearInterval(interval);
  }, [count]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '6px',
        padding: '4px',
        height: '36px',
        ...waitingStyle,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: index === activeIndex ? activeColor : defaultColor,
            transition: 'background-color 0.2s ease',
            ...circleStyle,
          }}
        />
      ))}
    </div>
  );
};

export default Waiting;
